<template>
  <div class="sku-edit-page">
    <div class="sku-edit-page__header">
      <Title title="编辑 SKU"></Title>
      <div class="sku-edit-page__actions">
        <el-button icon="el-icon-arrow-left" @click="back">返回</el-button>
        <el-button type="primary" icon="el-icon-check" :loading="saving" @click="save">保存</el-button>
      </div>
    </div>

    <SkuForm v-if="loaded" ref="skuForm" :value="form" :plans="plan_list"></SkuForm>
  </div>
</template>

<script>
import Title from './components/Title'
import SkuForm from './components/SkuForm'
import apis from '@/api/index'

export default {
  name: 'UpdateSku',
  components: {
    Title,
    SkuForm
  },
  data() {
    return {
      loaded: false,
      saving: false,
      plan_list: [],
      form: {}
    }
  },
  methods: {
    getPlans() {
      return apis.license.readPlans({ page_num: 1, page_size: 200 }).then(res => {
        const data = res.data.data || {}
        this.plan_list = data.list || []
      })
    },
    readOne() {
      const id = this.$route.query.id || (this.$route.params.obj && this.$route.params.obj.id)
      if (!id) {
        this.$message({ message: 'SKU 参数不能为空', type: 'error' })
        this.back()
        return Promise.resolve()
      }
      return apis.activation_code.readOneSku({ sku_id: id }).then(res => {
        if (!res.data.code) {
          this.$message({ message: res.data.msg, type: 'error' })
          this.back()
          return
        }
        this.form = res.data.data || {}
        this.loaded = true
      })
    },
    save() {
      this.$refs.skuForm.validate(valid => {
        if (!valid) return
        this.saving = true
        apis.activation_code.saveSku(this.$refs.skuForm.getForm()).then(res => {
          this.$message({ message: res.data.msg, type: res.data.code ? 'success' : 'error' })
          if (res.data.code) {
            this.$router.push({ name: 'codetypeList' })
          }
        }).finally(() => {
          this.saving = false
        })
      })
    },
    back() {
      this.$router.push({ name: 'codetypeList' })
    }
  },
  mounted() {
    Promise.all([this.getPlans(), this.readOne()]).catch(err => {
      this.$message({ message: String(err), type: 'error' })
    })
  }
}
</script>

<style lang="scss" scoped>
.sku-edit-page {
  padding: 15px;
}

.sku-edit-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
}

.sku-edit-page__actions {
  display: flex;
  gap: 10px;
}
</style>
